import React from "react";
import { Box, Button, Typography } from "@mui/material";

const DevIdeModuleActions = ({
  modules,
  selectedModule,
  onDownloadZip,
  onDownloadZipWithDocs,
  onAgentExportPackage,
  onCopyExportAgentHandoffSummary,
  onOpenImportZip,
  onOpenImportZipWithDocs,
  onOpenNewModule,
  onOpenNewFile,
  onOpenNewSql,
  onRunBackendScan,
  onRunFrontendScan,
  backendActionLoading,
  frontendActionLoading,
  activeChange,
  sqlError,
  sqlLoading,
  sqlFiles,
}) => {
  return (
    <Box mt={1} sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      <Button
        variant="outlined"
        size="small"
        onClick={onDownloadZip}
        disabled={!modules.length && selectedModule !== "ALL"}
      >
        Download module ZIP
      </Button>

      <Button variant="outlined" size="small" onClick={onDownloadZipWithDocs}>
        Download ZIP with docs
      </Button>

      <Button
        variant="contained"
        size="small"
        onClick={onAgentExportPackage}
        disabled={!activeChange || !activeChange.id}
      >
        Agent Export Package
      </Button>

      <Button
        variant="outlined"
        size="small"
        onClick={() => onCopyExportAgentHandoffSummary?.({ includeDiffs: false })}
        disabled={!activeChange || !activeChange.id}
      >
        Copy Agent Handoff Summary
      </Button>

      <Button
        variant="outlined"
        size="small"
        onClick={() => onCopyExportAgentHandoffSummary?.({ includeDiffs: true })}
        disabled={!activeChange || !activeChange.id}
      >
        Copy Summary with Diffs
      </Button>

      <Button variant="outlined" size="small" onClick={onOpenImportZip}>
        Import files from ZIP
      </Button>

      <Button variant="outlined" size="small" onClick={onOpenImportZipWithDocs}>
        Import ZIP with docs
      </Button>

      <Button variant="outlined" size="small" onClick={onOpenNewModule}>
        New module
      </Button>

      <Button
        variant="outlined"
        size="small"
        onClick={onOpenNewFile}
        disabled={!modules.length && selectedModule === "ALL"}
      >
        New file
      </Button>

      <Button
        variant="outlined"
        size="small"
        onClick={onOpenNewSql}
        disabled={!activeChange || !activeChange.id}
      >
        New SQL (CHG)
      </Button>

      <Button
        variant="outlined"
        size="small"
        onClick={onRunBackendScan}
        disabled={backendActionLoading}
      >
        {backendActionLoading ? "Running Backend..." : "Run Backend Scan"}
      </Button>

      <Button
        variant="outlined"
        size="small"
        onClick={onRunFrontendScan}
        disabled={frontendActionLoading}
      >
        {frontendActionLoading ? "Running Frontend..." : "Run Frontend Scan"}
      </Button>

      {activeChange && activeChange.id && (
        <Typography
          variant="caption"
          color={sqlError ? "error" : "text.secondary"}
          sx={{ display: "block", mt: 0.5 }}
        >
          {sqlError
            ? `SQL: ${sqlError}`
            : sqlLoading
            ? "SQL: loading..."
            : `SQL files for change: ${(sqlFiles || []).length}`}
        </Typography>
      )}
    </Box>
  );
};

export default DevIdeModuleActions;
